import { useEffect, useRef } from 'react';

export const ADMIN_NOTIFICATION_EVENT = 'crm:admin-notification';

export const ADMIN_NOTIFICATION_TYPES = Object.freeze({
  profileCreated: 'profile.created',
  accountOpened: 'account.opened',
  documentUploaded: 'document.uploaded',
  depositInitiated: 'deposit.initiated',
  withdrawalInitiated: 'withdrawal.initiated',
});

export function publishAdminNotification(notification) {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(ADMIN_NOTIFICATION_EVENT, {
    detail: notification,
  }));
}

export function useAdminNotificationRefresh(types, onRefresh) {
  const onRefreshRef = useRef(onRefresh);
  onRefreshRef.current = onRefresh;

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const allowedTypes = new Set(
      (Array.isArray(types) ? types : [types])
        .map((type) => String(type || '').trim())
        .filter(Boolean),
    );

    if (allowedTypes.size === 0) {
      return undefined;
    }

    const listener = (event) => {
      const notification = event?.detail || {};
      const type = String(notification?.type || '').trim();
      if (!allowedTypes.has(type)) {
        return;
      }

      onRefreshRef.current(notification);
    };

    window.addEventListener(ADMIN_NOTIFICATION_EVENT, listener);

    return () => {
      window.removeEventListener(ADMIN_NOTIFICATION_EVENT, listener);
    };
  }, [types]);
}
